import { apiSlice } from '@/features/api/apiSlice';

export type GdprUserExport = {
  exportedAt: string;
  user: {
    id: string;
    email: string;
    name: string | null;
    avatarUrl: string | null;
    createdAt: string;
    lastLoginAt: string | null;
  };
  memberships: Array<{
    role: string;
    joinedAt: string | null;
    organization: { id: string; name: string; slug: string };
  }>;
  sessions: unknown[];
  oauthIdentities: unknown[];
  note: string;
};

export type GdprAuditExport = {
  exportedAt: string;
  organizationId: string;
  events: Array<{
    id: string;
    actorId: string | null;
    action: string;
    entityType: string | null;
    entityId: string | null;
    payloadDiff: unknown;
    ip: string | null;
    userAgent: string | null;
    createdAt: string;
  }>;
};

export const gdprApi = apiSlice.injectEndpoints({
  endpoints: (b) => ({
    exportMe: b.mutation<GdprUserExport, void>({
      query: () => ({ url: '/gdpr/export/me', method: 'GET' }),
    }),
    exportOrgAudit: b.mutation<GdprAuditExport, void>({
      query: () => ({ url: '/gdpr/export/audit', method: 'GET' }),
    }),
    forgetMe: b.mutation<void, void>({
      query: () => ({ url: '/gdpr/me', method: 'DELETE' }),
    }),
  }),
});

export const { useExportMeMutation, useExportOrgAuditMutation, useForgetMeMutation } = gdprApi;
